import PropTypes from "prop-types";
import { useContext } from "react";
import AppGlobalsContext from "app/AppGlobalsContext";
import { RESOLUTION } from "app/constants";
import FaqBreadcrumb from "app/pages/Faq/FaqBreadcrumb/FaqBreadcrumb";
import FaqNav from "app/pages/Faq/FaqNav/FaqNav";

const FaqLayout = ({ children = "", faqCategories, article = {} }) => {
	const { resolution } = useContext(AppGlobalsContext);
	const isDesktop = resolution === RESOLUTION.LARGE || resolution === RESOLUTION.XLARGE;

	return (
		<div className="faq__main">
			{isDesktop && (
				<>
					<div className="faq__breadcrumb">
						<FaqBreadcrumb
							faqCategories={faqCategories}
							faqArticleTitle={article.title}
						/>
					</div>
					<div className="faq__nav">
						<FaqNav faqCategories={faqCategories} />
					</div>
				</>
			)}
			<div className="faq__content">{children}</div>
		</div>
	);
};

FaqLayout.propTypes = {
	faqCategories: PropTypes.array,
	article: PropTypes.object,
	children: PropTypes.any,
};

export default FaqLayout;
